<template>
    <div>
        <div ref="map" class="monitor-map"></div>
        <div class="caption grey--text mt-1">
            ตำแหน่งล่าสุดเท่าที่โทรศัพท์คนขับส่งมาได้ ไม่ใช่ตำแหน่งปัจจุบันแบบต่อเนื่อง
        </div>
    </div>
</template>
<script>
// The stylesheet is a static import (not part of the dynamic Leaflet load
// below) because webpack 4 / vue-cli 4 on this repo does not reliably support
// a dynamic import() of CSS -- it fails silently, leaving an unstyled map
// with no error to point at. It's ~15 KB, so paying for it in the main
// bundle for everyone costs far less than a silent breakage for whoever
// opens this tab.
import 'leaflet/dist/leaflet.css'

// The map is a SECOND look at the same rows the list already shows, so it holds
// no state and computes nothing: every number on it came from fleetBoard.
//
// Leaflet is loaded with a dynamic import() so the main bundle is untouched for
// everyone who never opens this tab -- which is most people, most days.
//
// OpenStreetMap rather than Google: no API key, no billing, and nothing that
// must stay secret added to a repo whose Firebase config is already committed.
// The driver's own นำทาง button still hands Google the destination, where the
// ซอย-level detail actually matters.
export default {
    props: {
        board: { type: Array, default: () => [] }
    },
    data () {
        return { map: null, layer: null, L: null, isDestroyed: false, fittedPlates: '' }
    },
    watch: {
        board () { this.draw() }
    },
    methods: {
        async init () {
            const L = await import('leaflet')
            // The await above is a window in which the tab can close and this
            // component be destroyed; a map built after that has no owner left
            // to remove it, so bail before touching this.L or the DOM ref.
            if (this.isDestroyed || !this.$refs.map) return
            this.L = L.default || L
            this.map = this.L.map(this.$refs.map).setView([13.7563, 100.5018], 10)
            this.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 18,
                // Required by the OSM tile usage policy.
                attribution: '© OpenStreetMap contributors'
            }).addTo(this.map)
            this.layer = this.L.layerGroup().addTo(this.map)
            this.draw()
        },
        colorFor (level) {
            if (level === 'veryLate') return '#d32f2f'
            if (level === 'late') return '#f57c00'
            if (level === 'unknown') return '#9e9e9e'
            return '#388e3c'
        },
        draw () {
            if (!this.map || !this.layer) return
            this.layer.clearLayers()
            const points = []
            const plates = []
            this.board.forEach(truck => {
                const ping = truck.ping
                if (!ping || ping.freshness === 'none') return
                const marker = this.L.circleMarker([ping.lat, ping.lng], {
                    radius: 9,
                    color: '#ffffff',
                    weight: 2,
                    fillColor: this.colorFor(truck.delayLevel),
                    fillOpacity: 1
                })
                marker.bindTooltip(truck.regNum + ' · อัปเดต ' + ping.ageMinutes + ' นาทีที่แล้ว', {
                    permanent: false
                })
                marker.addTo(this.layer)
                points.push([ping.lat, ping.lng])
                plates.push(truck.regNum)
            })
            // Fit only when the SET of trucks on the map changes. draw() runs on
            // every board change, and a board changes on every ping, so fitting
            // unconditionally would yank the view back from wherever the
            // dispatcher had panned it -- every few seconds, with a fleet out.
            // Sorted, because fleetBoard re-ranks the same trucks constantly and
            // a re-ranking is not a new set.
            const key = plates.slice().sort().join('|')
            if (points.length && key !== this.fittedPlates) {
                this.map.fitBounds(points, { padding: [40, 40], maxZoom: 13 })
            }
            this.fittedPlates = key
        }
    },
    mounted () { this.init() },
    beforeDestroy () {
        this.isDestroyed = true
        if (this.map) { this.map.remove(); this.map = null }
    }
}
</script>
<style scoped>
.monitor-map {
    height: 60vh;
    min-height: 320px;
    width: 100%;
}
</style>
